<template>
  <ul class="nav nav-sidebar">
    <li
      class="nav-item-header text-center"
      v-text="$t('general.review_us_header_text')"
    />
    <li v-for="link in links" :key="link.url" class="nav-item p-2">
      <a :href="link.url" target="_blank" class="text-center">
        <b-img :src="link.image" fluid />
      </a>
    </li>
  </ul>
</template>

<script>
import google from '../assets/images/review-us-on-google.jpg'
import trustpilot from '../assets/images/review-us-on-trustpilot.png'
import facebook from '../assets/images/review-us-on-facebook.png'
import linkedin from '../assets/images/review-us-on-linkedIn.jpg'

export default {
  data() {
    return {
      links: [
        {
          url: 'https://g.page/r/CTNegZLfD1cVEBM/review',
          image: google,
        },
        {
          url: 'https://www.trustpilot.com/evaluate/airporttaxis.com',
          image: trustpilot,
        },
        {
          url: 'https://www.facebook.com/book.your.airport.taxi',
          image: facebook,
        },
        {
          url: 'https://www.linkedin.com/company/airport-transfers-and-taxi/',
          image: linkedin,
        },
      ],
    }
  },
}
</script>
